module.exports = __webpack_public_path__ + "img/icon_instagram_rotate_txt.6b3fd81e.svg";